import { useState } from "react";
import ApplicationModal from "./ApplicationModal";
import useJobListings from "./useJobListings";
import "./JobHighlightsOverlay.css";

const JobHighlightsOverlay = () => {
  const { jobs, loading, error } = useJobListings();

  const [selectedJob, setSelectedJob] = useState(null);

  return (
    <>
      <div className="career-page-outer">
        <div className="job-overlay-wrapper">
          <div className="blurred-background">
            <img src="/assets/images/career/join.jpg" alt="Join our team" />
          </div>

          <div className="job-cards-container">
          {loading && (
            <p className="job-cards-status">Loading open positions...</p>
          )}

          {error && (
            <p className="job-cards-status job-cards-status--error">{error}</p>
          )}

          {!loading &&
            !error &&
            jobs.map((job) => (
              <div className="job-card" key={job.id}>
                <h3>{job.title}</h3>

                <p>Experience: {job.experience}</p>

                <p>Qualification: {job.qualification}</p>

                <div className="tags">
                  <span>{job.type}</span>
                  <span>{job.location}</span>
                </div>

                <div className="skills">
                  {job.skills.map((skill, i) => (
                    <span key={i} className="skill-badge">
                      {skill}
                    </span>
                  ))}
                </div>

                <button
                  className="apply-btn"
                  onClick={() => setSelectedJob(job)}
                >
                  Apply Now
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {selectedJob && (
        <ApplicationModal
          job={selectedJob}
          onClose={() => setSelectedJob(null)}
        />
      )}
    </>
  );
};

export default JobHighlightsOverlay;
